import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of, throwError } from 'rxjs';
import { switchMap, tap, catchError } from 'rxjs/operators';
import {
    ELoginActions,
    GetToken,
    GetTokenSuccess,
    GetTokenFailure,
    DeleteToken,
    DeleteTokenSuccess
} from '../actions/login.actions';

import { LoginService } from '../../services/login.service';
import { TokenLocalStorageService } from '../../services/token-local-storage.service';
import { LoginResponseInterface } from '../../models/login-response.interface';
import { Store } from '@ngrx/store';
import { AbstractEffects } from '../../../shared/abstract.effects';
import { GetCustomer } from '../../../account/store/actions/customer.actions';
import { AlertMessageInterface } from '../../../shared/models/alert-message.interface';
import { GetAlertMessage } from '../../../shared/store/actions/alert-message.actions';
import { LoginRequestInterface } from '../../models/login-request.interface';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class LoginEffects extends AbstractEffects {

    payload: LoginRequestInterface = null;

    constructor(
        private loginService: LoginService,
        private localStorageService: TokenLocalStorageService,
        private actions: Actions,
        public override store: Store<any>
    ) {
        super(store);
    }

    getUser = createEffect(() => this.actions.pipe(
        ofType<GetToken>(ELoginActions.GetToken),
        tap(params => {
            this.payload = params.payload;
        }),
        switchMap((action) => this.loginService.getToken(this.payload)),
        switchMap((response: LoginResponseInterface|{customerId: string}) => of(new GetTokenSuccess(response))),
        tap(action => {
            if ('token' in action.payload) {
                this.localStorageService.save(action.payload, true);
                if (action.payload.isAdminProFleet) {
                    localStorage.setItem(ConstsHelper.LOCAL_STORAGE_ADMIN_PRO_FEET_TOKEN, action.payload.token);
                }
                this.store.dispatch(new GetCustomer());
            }
        }),
        catchError((error: HttpErrorResponse) => {
            if (error.error && error.error.error_message && error.error.error_message.includes('blocked')) {
                const alertMessage = {message: ConstsHelper.ERROR_MESSAGE_MFA_BLOCKED, code: 400} as AlertMessageInterface;
                this.store.dispatch(new GetAlertMessage(alertMessage));
            } else {
                this.DisplayMessage('error_authentication', 400, new GetTokenFailure());
            }
            return throwError(error);
        })
    ));

    deleteLocalStorage = createEffect(() => this.actions.pipe(
        ofType<DeleteToken>(ELoginActions.DeleteToken),
        switchMap(() => of(new DeleteTokenSuccess())),
        tap(() => {
            this.localStorageService.clear();
        })
    ));
}
